import styled from "styled-components";

export const CapturaCamaraContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const ContainerCanvasAndBtn = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  position: relative;
`;

export const CanvasContainer = styled.div`
  position: relative;
  width: 640px;
  height: 480px;
  overflow: hidden;
  video {
    transform: scale(${({ $scale }) => $scale || 1});
    transform-origin: center center;
  }
  .canvasCaptura {
    position: absolute;
    left: 0;
    top: 0;
  }
  .background-second {
    display: ${({ $active }) => !$active && "none"};
    position: absolute;
    right: ${({ $isTerminal }) => !$isTerminal && "8px"};
    left: ${({ $isTerminal }) => $isTerminal && "36%"};
    top: 8px;
    background: ${({ $isTerminal }) => !$isTerminal && "rgba(0, 0, 0, 0.5)"};
    border-radius: 8px;
    padding: ${({ $isTerminal }) => !$isTerminal && "4px 8px"};
  }
  .second-back {
    font-size: ${({ $isTerminal }) => $isTerminal && "30vh"};
    text-shadow: 
    -2px -2px 0 #000,  
     2px -2px 0 #000,
    -2px  2px 0 #000,
     2px  2px 0 #000;
    color: var(--color-white);
  }
`;

export const BtnContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  .btn,
  .btn-ok {
    height: 44px;
    padding: 0 16px;
    border-radius: 8px;
  }
  .btn-circle {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;

export const RightControls = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  position: absolute;
  left: 660px;
  .btn-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .btn-tomar-foto {
    margin-top: 16px; /* separación extra para diferenciar del +/- */
    height: 44px;
    padding: 0 16px;
    border-radius: 8px;
  }
`;
